import * as React from "react";
const LinkedInIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="0.5" y="0.5" width="41" height="41" rx="5.5" fill="white" />
    <rect x="0.5" y="0.5" width="41" height="41" rx="5.5" stroke="black" />
    <g clipPath="url(#clip0_750_17798)">
      <path
        d="M38.0391 1H3.95312C2.32031 1 1 2.28906 1 3.88281V38.1094C1 39.7031 2.32031 41 3.95312 41H38.0391C39.6719 41 41 39.7031 41 38.1172V3.88281C41 2.28906 39.6719 1 38.0391 1ZM12.8672 35.0859H6.92969V15.9922H12.8672V35.0859ZM9.89844 13.3906C7.99219 13.3906 6.45313 11.8516 6.45313 9.95312C6.45313 8.05469 7.99219 6.51562 9.89844 6.51562C11.7969 6.51562 13.3359 8.05469 13.3359 9.95312C13.3359 11.8437 11.7969 13.3906 9.89844 13.3906ZM35.0859 35.0859H29.1562V25.8047C29.1562 23.5937 29.1172 20.7422 26.0703 20.7422C22.9844 20.7422 22.5156 23.1562 22.5156 25.6484V35.0859H16.5938V15.9922H22.2812V18.6016H22.3594C23.1484 17.1016 25.0859 15.5156 27.9688 15.5156C33.9766 15.5156 35.0859 19.4688 35.0859 24.6094V35.0859V35.0859Z"
        fill="#0A66C2"
      />
    </g>
    <defs>
      <clipPath id="clip0_750_17798">
        <rect width="40" height="40" fill="white" transform="translate(1 1)" />
      </clipPath>
    </defs>
  </svg>
);
export default LinkedInIcon;
